import React, { FC } from 'react'
import { createStyles, makeStyles, Theme, InputLabel, FormControl, Input, InputProps } from '@zn-material-ui'
import classNames from 'classnames'

export type IInputProps = InputProps

interface IProps extends InputProps {
  type?: string
  showLabel?: boolean
  value?: string
  placeholder?: string
  label?: string
  containerStyle?: any
}

const ZnInput: FC<IProps> = ({
  showLabel = false,
  label = '',
  containerStyle,
  ...inputProps
}) => {
  const classes = useStyles()
  return (
    <FormControl
      className={classNames(
        inputProps.endAdornment && classes.captchaMargin,
        classes.textField,
        containerStyle
      )}
      error={showLabel}
    >
      {label && (
        <InputLabel
          htmlFor="input-label"
          classes={{ root: classes.inputLabel }}
          shrink={true}
        >
          {label}
        </InputLabel>
      )}
      <Input
        id="input-label"
        classes={{ root: classes.inputText, underline: classes.underline }}
        {...inputProps}
      />
    </FormControl>
  )
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    textField: {
      width: 460,
    },
    inputLabel: {
      fontSize: 20,
    },
    inputText: {
      fontSize: 18,
      marginTop: '25px !important',
    },
    captchaMargin: {
      marginTop: 25,
    },
    underline: {
      transition: 'unset',
      '&:before': {
        borderBottom: '1px solid #E9EBF0 !important',
      },
      '&:after': {
        transition: 'unset',
        borderBottom: 'none',
      },
    },
  })
)

export default ZnInput
